import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunkWrapper } from 'redux/thunk/createAsyncThunkWrapper';
import { getBasketData } from 'services/getBasketData';
import { FetchSuspendBasketPayload, SuspendBasketState } from 'types/baskets';
import { getDefaultCompanyId } from 'utils/helpers';

const initialState: SuspendBasketState = {
    suspendRecords: [],
    loading: false,
    error: null,
    loadMore: false,
};

export const fetchSuspendBasket = createAsyncThunkWrapper<any, FetchSuspendBasketPayload>(
    'suspend/fetchSuspendBasket',
    async ({ status, subType, headers, name }: FetchSuspendBasketPayload, { getState }) => {
        const { pageSize, pageNumber } = headers;
        const state: any = getState();
        const defaultCompanyId = getDefaultCompanyId(state);
        if (!defaultCompanyId) {
            return;
        }
        const res = await getBasketData({ status, subType, companyId: defaultCompanyId, headers, name });
        return { response: res, pageNumber, pageSize };
    }
);

const suspendBasketSlice = createSlice({
    name: 'suspendBasket',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchSuspendBasket.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchSuspendBasket.fulfilled, (state, action) => {
            state.loading = false;
            if (action?.payload) {
                const { response, pageNumber, pageSize } = action.payload || {};
                const { events } = response || {};
                if (events?.length >= pageSize) {
                    state.loadMore = true;
                } else {
                    state.loadMore = false;
                }
                if (pageNumber === 0) {
                    state.suspendRecords = events;
                } else {
                    state.suspendRecords = [...state.suspendRecords, ...(events || [])];
                }
            }
        });
        builder.addCase(fetchSuspendBasket.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message || null;
        });
    },
});

export default suspendBasketSlice.reducer;
